module.exports = __webpack_public_path__ + "static/media/Logo G Gradien.49f54c67.png";